import styled from 'styled-components';

export const AttachmentsContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  gap: 1rem;
`;

export const AttachmentsTitle = styled.span`
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const AttachmentsItemContainer = styled.a`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  max-width: 40rem;

  .hefesto-icon {
    width: 24px;
    height: 24px;
  }

  .hefesto-icon svg {
    stroke: ${({ theme }) => theme.colors.blue6};
  }
`;

export const AttachmentsItemTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: 600;
  font-size: 1rem;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.blue6};

  cursor: pointer;

  padding-top: 12px;
  padding-bottom: 12px;

  &,
  :visited,
  :link,
  :active {
    color: ${({ theme }) => theme.colors.blue6};
    text-decoration: none;
  }
`;
